import React from 'react';
import { MenuButton as ChakraMenuButton, MenuButtonProps as ChakraMenuButtonProps } from '@chakra-ui/react';

export function MenuButton(props: ChakraMenuButtonProps) {
  return <ChakraMenuButton {...props} />;
}
